import { LocalProfile } from "@core/model/local-profile";
import { PROFILE } from "@core/utility/settings";
import StorageService from "@shared/services/storage.service";
import { useCallback } from "react";
import { appFeature } from "../../app.feature";

export function useUserIdentity() {
  const getUser = useCallback(
    () => StorageService.load<LocalProfile>(PROFILE),
    []
  );

  const getUserRole = useCallback(() => {
    const user = StorageService.load<LocalProfile>(PROFILE);
    if (!user) return "";

    return user.roleName.toLowerCase();
  }, []);

  const isExpectedRole = (currentRole: string, specifiedRoles: string[]) => {
    const levelRole = specifiedRoles.map((x) => x.toLowerCase());
    const isExpected = levelRole.indexOf(currentRole.toLowerCase()) >= 0;
    return isExpected;
  };

  const userIsBranchAdmin = useCallback(() => {
    const user = StorageService.load<LocalProfile>(PROFILE);
    if (!user) return false;

    const role = user.roleName || "";
    const levelRole = ["branchadmin"];
    const hasAdminLevel = isExpectedRole(role, levelRole);
    return hasAdminLevel;
  }, []);

  const userIsAdmin = useCallback(() => {
    const user = StorageService.load<LocalProfile>(PROFILE);
    if (!user) return false;

    const role = user.roleName || "";
    const levelRole = ["admin"];
    const hasAdminLevel = isExpectedRole(role, levelRole);
    return hasAdminLevel;
  }, []);

  const userIsOwner = useCallback(() => {
    const user = StorageService.load<LocalProfile>(PROFILE);
    if (!user) return false;

    const role = user.roleName || "";
    const levelRole = ["owner"];
    const hasAdminLevel = isExpectedRole(role, levelRole);
    return hasAdminLevel;
  }, []);

  const userIsManagement = useCallback(() => {
    const user = StorageService.load<LocalProfile>(PROFILE);
    if (!user) return false;

    const role = user.roleName || "";
    const levelRole = ["owner", "admin"];
    const hasAdminLevel = isExpectedRole(role, levelRole);
    return hasAdminLevel;
  }, []);

  const hasAccess = useCallback(
    (accessItem: string) => {
      const userRole = getUserRole();
      const currentFeature = appFeature as any;

      if (!userRole) {
        throw new Error("Unrecognized role");
      }

      const accessibleMenu =
        currentFeature.config["feature-menu-access"]?.[userRole];
      const hasAccess = (accessibleMenu as string[]).indexOf(accessItem) >= 0;
      return hasAccess;
    },
    [getUserRole]
  );

  return {
    userIsManagement,
    userIsAdmin,
    userIsBranchAdmin,
    getUser,
    userIsOwner,
    getUserRole,
    hasAccess,
  };
}
